import React from 'react';
import { Snowflake } from 'lucide-react';
import type { ChatPhase } from '../data/script';
import { cx } from '../lib/hooks';
type Props = {
  phase: ChatPhase;
  /** How far through the current beat, 0 to 1. Drives the typing. */
  progress: number;
  message: string;
  reply: string;
};
export function ChatScene({
  phase,
  progress,
  message,
  reply
}: Props) {
  const typing = phase === 'type';
  const shown = typing ? reply.slice(0, Math.round(reply.length * Math.min(1, progress / 0.7))) : reply;
  const frozen = phase === 'hold' || phase === 'enter';
  return <div className={cx('pointer-events-none absolute inset-0 z-[15] flex items-center justify-center px-6', phase === 'enter' ? 'animate-[fadeOut_1.4s_ease-in_both]' : 'animate-[fadeIn_0.8s_ease_both]')} data-id="element-116" data-mp="2rnpq9p3chg2q">
      <div className="absolute inset-0 bg-[#07080C]/90 backdrop-blur-[12px]" data-id="element-117" data-mp="3ffo68mdqnzm7" />
      <div className={cx('relative w-full max-w-[540px] rounded-[26px] border border-white/10 bg-[#0F1118]/95 p-5 shadow-[0_40px_120px_-40px_rgba(0,0,0,0.9)]', phase === 'enter' && 'animate-[chatZoom_1.4s_cubic-bezier(0.6,0,0.4,1)_both]', phase === 'return' && 'animate-[chatSettle_0.9s_cubic-bezier(0.2,0.8,0.2,1)_both]')} data-id="element-118" data-mp="3ah36eo2efhya">
        <div className="flex h-6 items-center justify-between" data-id="element-119" data-mp="maxncql12l8">
          <div className="flex gap-1.5" data-id="element-120" data-mp="jeyjl3007v7">
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" data-id="element-121" data-mp="4o4t96lx7gej" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" data-id="element-122" data-mp="9mg33hc7tqwr" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" data-id="element-123" data-mp="9kmxm5dc9cqc" />
          </div>
          {frozen && <span className="flex items-center gap-1.5 rounded-full bg-white/[0.08] px-2.5 py-1 text-[11px] font-medium text-[#C9CCD8] animate-[fadeIn_0.4s_ease_both]" data-id="element-124" data-mp="ef97u57ooz8u">
              <Snowflake className="h-3 w-3" data-id="element-125" data-mp="ocnbf48idtjq" />
              Frozen
            </span>}
        </div>
        <div className="mt-5 flex justify-end" data-id="element-126" data-mp="sdgyxwi1h6c3">
          <div className="max-w-[80%] rounded-2xl rounded-br-md bg-white/[0.08] px-4 py-2.5 text-[15px] leading-6 text-[#EDEEF2]" data-id="element-127" data-mp="2pdbqubi4c0yw">
            {message}
          </div>
        </div>
        <div className="mt-4 flex gap-3" data-id="element-128" data-mp="2kcnudab4erxa">
          <div className="mt-0.5 flex h-7 w-7 shrink-0 flex-col items-center justify-center gap-[3px] rounded-lg border border-white/[0.08] bg-white/[0.04]" data-id="element-129" data-mp="2y6x6ry60ro9w">
            <span className="h-[2.5px] w-3.5 rounded-full bg-[#FBBF24]" data-id="element-130" data-mp="3842yn8mgjjb6" />
            <span className="h-[2.5px] w-3.5 rounded-full bg-[#22D3EE]" data-id="element-131" data-mp="3828evxmx9x8o" />
            <span className="h-[2.5px] w-3.5 rounded-full bg-[#A78BFA]" data-id="element-132" data-mp="3346sb2qaffsg" />
          </div>
          <p className="min-h-7 text-[17px] leading-7 text-[#EDEEF2]" data-id="element-133" data-mp="3h3q01uf6sp48">
            {shown}
            <span className={cx('ml-0.5 inline-block h-[18px] w-[8px] translate-y-[3px] rounded-[1px] bg-[#EDEEF2]/85', !typing && 'animate-[blink_1.1s_steps(1)_infinite]')} data-id="element-134" data-mp="3d2we36lb1kdz" />
          </p>
        </div>
      </div>
    </div>;
}